import React, { useState, useEffect, useCallback } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import { useElapsedTime } from "use-elapsed-time";

import Header from "./components/Header";
import Home from "./components/Home";
import PlaneDetails from "./components/PlaneDetails";

function Planes() {
	const [imagePath, setImagePath] = useState(
		"https://www.aviation24.be/wp-content/uploads/2015/03/747-8i.jpeg"
	);
	const [data, setData] = useState(null);
	const [imagesToLoad, setImagesToLoad] = useState([]);
	const [loadedImages, setLoadedImages] = useState(0);
	const [loading, setLoading] = useState(true);
	const [navActive, setNavActive] = useState(false);
	const { elapsedTime } = useElapsedTime(true);
	const path = useLocation().pathname.split("/")[2];

	const fetchData = async () => {
		try {
			const res = await fetch("./data.json");
			const json = await res.json();
			setData(json);
		} catch (err) {
			console.error(err);
		}
	};

	const preloadImage = useCallback(
		src => {
			if (imagesToLoad.includes(src)) return;
			const image = new Image();
			image.src = src;
			setImagesToLoad(prevVal => [...prevVal, src]);
			image.onload = () => {
				setLoadedImages(prevVal => prevVal + 1);
			};
		},
		[imagesToLoad]
	);

	const preloadImages = useCallback(() => {
		preloadImage("https://www.aviation24.be/wp-content/uploads/2015/03/747-8i.jpeg");

		if (data === null) return;
		Object.values(data.Content).forEach(manufacture => {
			preloadImage(manufacture.Picture);
			if (path === undefined) return true;
			if (!Object.keys(manufacture).includes(path)) return true;
			manufacture[path].Pictures.forEach(picture => preloadImage(picture));
		});
	}, [data, path, preloadImage]);

	useEffect(() => {
		if (imagesToLoad.length === loadedImages && imagesToLoad.length !== 0) {
			if (elapsedTime < 0.3) {
				setTimeout(() => {
					setLoading(false);
				}, 300 - elapsedTime * 100);
				return;
			}
			setLoading(false);
		}
	}, [imagesToLoad, loadedImages, elapsedTime]);

	useEffect(() => {
		fetchData();
	}, []);
	useEffect(() => {
		preloadImages();
	}, [data, preloadImages]);

	if (data == null || loading)
		return (
			<div className="app">
				<div className="loader_container">
					<div className="big ball-spin-fade-loader">
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			</div>
		);
	return (
		<div className="planes">
			<Header airplanes={data} setImagePath={setImagePath} setNavActive={setNavActive} />
			<Switch>
				<Route
					path="/samoloty"
					exact
					render={() => <Home imagePath={imagePath} navActive={navActive} />}
				/>
				<Route
					path="/samoloty/:id"
					render={() => <PlaneDetails airplanes={data} navActive={navActive} />}
				/>
			</Switch>
		</div>
	);
}

export default Planes;
